import { useParams } from 'react-router';
import UnAuthorizedMessage from '@/components/Permission/UnauthorizedMessage';
import { notificationHighlightStorageKey } from '@/features/ApplicationForm/utils/notifications/statusCatalog';
import { useApplicationForm } from '@/hooks/ReactQueryHooks/useApplicationFromQuery';
import { usePermission } from '@/hooks/usePermission';
import { EPermission } from '@/types/Permission';
import { ApplicationNav } from '../ApplicationNav';
import { FormNotificationsPage } from './FormNotificationsPage';

/**
 * Route entry for Rover application form notification settings.
 * URL: /terminal/rover/application_forms/:applicationFormId/notifications
 */

export const ApplicationFormNotifications = () => {
  const { applicationFormId } = useParams<string>();
  const { hasPermission } = usePermission();
  const canEdit = hasPermission([EPermission.UPDATE_APPLICATION_FORM]);

  const fetchApplicationForm = useApplicationForm({
    formId: applicationFormId || '',
  });
  const applicationForm = fetchApplicationForm?.data?.data;

  if (!hasPermission([EPermission.READ_APPLICATION_FORM])) {
    return <UnAuthorizedMessage title='Unauthorized' message='You do not have permission to view application form notifications.' />;
  }

  if (!applicationFormId) {
    return (
      <>
        <ApplicationNav />
        <p className='text-sm text-gray-600'>Loading…</p>
      </>
    );
  }

  const programName = (applicationForm?.name as string) ?? 'Your program';
  const highlightApplicationStatusCode = sessionStorage.getItem(notificationHighlightStorageKey(applicationFormId));

  return (
    <>
      <ApplicationNav />
      <FormNotificationsPage
        formId={applicationFormId}
        programName={programName}
        canEdit={canEdit}
        highlightApplicationStatusCode={highlightApplicationStatusCode}
      />
    </>
  );
};

export default ApplicationFormNotifications;
